import ImageUpload from "./ImageUpload.presenter";

export default ImageUpload;
